/**
 * 캔버스를 이미지로 내보낸다.
 *
 * 아이폰 홈화면 앱에서는 <a download> 가 조용히 실패한다. 눌렀는데
 * 아무 일도 안 일어나면 사용자는 고장난 줄 안다. 그래서 공유 시트를
 * 먼저 시도한다 — 인스타그램으로 바로 넘길 수 있어 목적에도 맞는다.
 *
 *   1. 공유 시트   폰 (사파리 · 홈화면 앱 · 안드로이드 크롬)
 *   2. 다운로드    데스크톱 (어차피 인스타에 못 올리니 파일이 맞다)
 *   3. 길게 눌러 저장   위 둘 다 막힌 경우
 */

/** @returns {Promise<Blob>} */
function toBlob(canvas) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((b) => (b ? resolve(b) : reject(new Error("이미지를 만들지 못했어요"))), "image/png");
  });
}

/**
 * @returns {Promise<"shared"|"downloaded"|"manual">} 어떻게 처리됐는지
 */
export default async function exportCanvas(canvas, filename) {
  const blob = await toBlob(canvas);
  const file = new File([blob], filename, { type: "image/png" });

  // 1. 공유 시트. canShare 로 먼저 물어야 한다 — share 는 있는데
  //    파일 공유는 못 하는 브라우저가 있다.
  if (navigator.canShare?.({ files: [file] })) {
    try {
      await navigator.share({ files: [file] });
      return "shared";
    } catch (e) {
      // 사용자가 시트를 닫은 것은 실패가 아니다. 다음 단계로 넘기지 않는다.
      if (e?.name === "AbortError") return "shared";
    }
  }

  // 2. 다운로드
  try {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    // 즉시 해제하면 저장 전에 사라지는 브라우저가 있다
    setTimeout(() => URL.revokeObjectURL(url), 10000);
    return "downloaded";
  } catch {
    return "manual";
  }
}
